module.exports = __webpack_public_path__ + "media/img/search-5bab302d5801ece5570f91e3f74c2d60.svg";